import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { mascaraMoedaReal } from "../../../utils/mascaras/mascaraMoedaReal";
import { SelectField } from "../../ui";

interface SelectNfsCompraProps {
  name: string;
  methods: any;
  workId?: string;
  supplierId?: string;
  disabled?: boolean;
  required?: boolean;
  label?: string;
}

export function SelectNfsCompras({
  name,
  methods,
  workId,
  supplierId,
  disabled = false,
  required = false,
  label = "Selecione uma Nota Fiscal",
}: SelectNfsCompraProps) {
  const [notas, setNotas] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await baseApiService.get("input-invoice/select");
      let notasRetorno = data.data.data || [];
      if (workId) {
        notasRetorno = notasRetorno.filter(
          (nota: any) => nota.workId === workId
        );
      }
      if (supplierId) {
        notasRetorno = notasRetorno.filter(
          (nota: any) => nota.supplierId === supplierId
        );
      }
      setNotas(notasRetorno);
    };
    fetchData();
  }, [workId, supplierId]);

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <SelectField
          label={label}
          value={field.value || ""}
          onChange={(e) => field.onChange(e.target.value)}
          required={required}
          disabled={disabled}
        >
          <option value="" />
          {notas.map((nota) => (
            <option key={nota.id} value={nota.id}>
              {`${nota.invoiceNumber} / Série: ${nota.series} | Obra: ${
                nota.work?.workName || "-"
              } | Valor: ${mascaraMoedaReal(
                nota.totalValue
              )} | Emissão: ${new Date(nota.issueDate).toLocaleDateString(
                "pt-BR"
              )} | Movimentações financeiras: ${
                nota.hasFinancialMovements ? "Sim" : "Nenhuma"
              }`}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}
